<script lang="ts">
import { LANG_EN } from '@/app/const';
import { ComplaintInfo } from '@/interface/Complaint.interface';
import { UserEndReason } from '@/interface/UserEndReason.interface';
import { masterService } from '@/services/serviceProvider';
import { ref } from 'vue';

export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        header: {
            type: String,
            default: 't-action-cancel'
        },
        cancelText: {
            type: String,
            default: 't-back'
        },
        confirmText: {
            type: String,
            default: 't-action-cancel'
        },
        complaint: {
            type: Object,
            default: {}
        }
    },
    emits: ['update:modelValue', 'onConfirm', 'onCancel'],
    setup() {
        const cancelReqForm = ref();
        return { cancelReqForm };
    },
    data() {
        return {
            request: this.complaint as ComplaintInfo,
            userEndReasons: [] as UserEndReason[],
            lang: this.$i18n.locale,
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
            }
        }
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        },
    },
    watch: {
        '$i18n.locale': function (newVal, oldVal) {
            this.lang = newVal;
        }
    },
    mounted() {
        this.getUserEndReasons();
    },
    methods: {
        async getUserEndReasons() {
            try {
                const res = await masterService.getEndReasons();
                if (res && res.status === 200) {
                    this.userEndReasons = res.data as UserEndReason[];
                }
            } catch (e) {
            }
        },
        async confirm() {
            const valid = await this.cancelReqForm.validate();
            if (valid.valid) {
                this.dialogShow = false;
                this.$emit('onConfirm', this.request);
            }
        },
        cancel() {
            this.request.userEndReasonId = undefined;
            this.request.userEndReason = undefined;
            this.dialogShow = false;
            this.$emit('onCancel')
        },
        userEndReasonText(userEndReasonId: number) {
            const endReason = this.userEndReasons.find(o => o.id === userEndReasonId)
            return this.lang === LANG_EN ? endReason?.reasonEn : endReason?.reasonTh;
        }
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="80%" :close-on-back="false" persistent>
        <v-form ref="cancelReqForm" class="admin-form app-form-input" validate-on="submit lazy"
            @submit.prevent="confirm">
            <v-card class="dialog-card">
                <v-toolbar density="compact">
                    <v-toolbar-title>{{ $t(header) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon="mdi-close" @click="cancel"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text-label">{{ $t('t-complaint-user-cancel-reason') }}</div>
                    <v-select v-model="request.userEndReasonId" :items="userEndReasons" :label="$t('t-please-select')"
                        hide-details="auto" item-value="id" density="comfortable" variant="outlined"
                        class="hide-float-label"
                        :rules="[rules.required(`${$t('t-please-select')}${$t('t-complaint-main-responsible-dpm')}`)]">
                        <template v-slot:item="{ props, item }">
                            <v-list-item v-bind="props" :title="userEndReasonText(item.raw.id)"></v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                            {{ userEndReasonText(item.raw.id) }}
                        </template>
                    </v-select>
                    <div v-if="request.userEndReasonId === 99" class="mt-3">
                        <div class="text-label">{{ $t('t-please-fill') }}</div>
                        <v-text-field v-model.trim="request.userEndReason" class="hide-float-label" variant="outlined"
                            hide-details="auto" density="comfortable" :label="$t('t-please-input')"
                            :rules="[rules.required(`${$t('t-please-fill')}`)]">
                        </v-text-field>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-container class="mx-0">
                        <div class="d-flex justify-end">
                            <v-btn @click="cancel" variant="outlined" color="primary" size="large">
                                {{ $t(cancelText) }}
                            </v-btn>
                            <v-btn @click="confirm" variant="flat" color="primary" size="large">
                                {{ $t(confirmText) }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>